import * as React from "react";

export class Fixture extends React.Component<{ top: string, bottom: string }, {}> {
    render() {
        return [
            <div className="rj-racing-next-races__top">{this.props.top}</div>,
            <div className="rj-racing-next-races__bottom">{this.props.bottom}</div>
        ]
    }
}